const drawerSections = {
    MANAGEMENT: 'ADMIN',
    NATIONAL_LEAGUE: 'NATIONAL LEAGUE',
    CHL: 'CHL',
    WOMENS_HOCKEY: "WOMEN'S HOCKEY",
    U21_ELIT: 'U-21 ELIT',
    U18_ELIT: 'U-18 ELIT',
};

export default drawerSections;
